// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-projects-flare-tsx": () => import("./../../../src/pages/projects/Flare.tsx" /* webpackChunkName: "component---src-pages-projects-flare-tsx" */),
  "component---src-pages-projects-mijo-tsx": () => import("./../../../src/pages/projects/MIJO.tsx" /* webpackChunkName: "component---src-pages-projects-mijo-tsx" */),
  "component---src-pages-projects-rx-watches-tsx": () => import("./../../../src/pages/projects/RXWatches.tsx" /* webpackChunkName: "component---src-pages-projects-rx-watches-tsx" */)
}

